import React, { useEffect, useState } from "react";
import { Row, Modal, Button , Form} from 'react-bootstrap';
import LoadingSpinner from '../LoadingSpinner/index';
import { ToastContainer, toast } from 'react-toastify';
import MyDatePicker from "../DatePicker/DatePicker";
import Select from 'react-select';

const TrainingModal = (props) => {
  const { trainingModal, setTrainingModal , row , selectedDate , setSelectedDate , selectedTime , setSelectedTime  , setIsShow } = props;
  const [isLoading, setIsLoading] = useState(false);
  const today = new Date().toISOString().split("T")[0];
  const isFormValid = selectedDate !== null && selectedTime !== null;
  const [schedule , setSchedule] = useState('');
  const [newDate , setNewDate] = useState('');

  const handleCloseModal = () => {
    setTrainingModal(false);
  };

  const timeOptions = [];
  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += 30) {
      const value = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
      timeOptions.push({ value, label: value });
    }
  }

  useEffect(()=>{
    setNewDate(row?.new_start_date)
    setSchedule(row?.selected_schedule)
  })


  return (
    <>
      <div>
        <ToastContainer position="top-center" />
        <LoadingSpinner isLoading={isLoading} />
        <Modal size="md" show={trainingModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Schedule For Training</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <Row>
                <div className="mt-1">
                  <div style={{ display: 'block' }}>
                    <p style={{ fontSize: '16px', fontWeight: 600 }}>Student's Availability in EST : </p> 
                    <p style={{ marginTop: '-10px' }}>
                      {schedule
                        .split('&&&') 
                        .map((entry, index) => (
                          <span key={index} style={{ display: 'block' }}> 
                            {entry.trim()}
                          </span>
                        ))}
                    </p>

                  </div>
                  <div style={{ display: 'flex', marginTop: '-10px' }}>
                    <p style={{ fontSize: '16px', fontWeight: 600 }}>Student Class Start Date : </p>
                    <p className="mx-1">{newDate}</p>
                  </div>

                  <div style={{ display: 'flex', marginTop: '20px' }}>
                    <p style={{ fontSize: '16px', fontWeight: 600 }}>Schedule on : </p>
                    <div style={{ marginLeft: '10px', marginTop: '-4px' }}>
                      <Form.Control
                        type="date"
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        min={today} 
                      />
                    </div>
                  </div>

                  <div style={{ display: 'flex', marginTop: '20px' }}>
                    <p style={{ fontSize: '16px', fontWeight: 600 }}>Schedule at : </p>
                    <div style={{ marginLeft: '15px', marginTop: '-4px', width: '200px' }}>
                      <Select
                        name="time"
                        className="basic-single"
                        classNamePrefix="Select Time"
                        options={timeOptions}
                        onChange={(selectedOption) => setSelectedTime(selectedOption)}
                      />
                    </div>
                  </div>

                  <div className="my-4 mx-0" style={{ backgroundColor: '#fcf8e3' }}>
                    <p className="p-2" style={{ fontSize: '14px' }}>
                      This <strong>will schedule</strong> the student for the training on the date/time selected above.
                      <strong>A confirmation email</strong> will be sent to the student along with training material.
                    </p>
                  </div>
                </div>
              </Row>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                setTrainingModal(false);
                setIsShow(true);
              }}
              disabled={!isFormValid} 
            >
              Schedule & Send Email
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default TrainingModal;
